// store/ui.js
import { defineStore } from 'pinia';
import { ref } from 'vue';
// Helper 함수 및 상수 임포트 (경로는 실제 프로젝트 구조에 맞게 수정)
import {
    getItemChartTypeInfo,
    getItemLegendInfo,
    shouldDisplayFiscalYear,
    shouldDisplayEmployeeIdGroup1,
    shouldDisplayEmployeeIdGroup2,
    getLinkReportPath,
    getInitialEmployeeId
} from '@/js/widgetHelpers';
import common from "@/js/common";
import { useUserStore } from '@/store/user';

export const useUiStore = defineStore('ui', () => {
    const isGlobalFullscreen = ref(false);
    const fullscreenLayout = ref([]);
    const activeSlideIndex = ref(0);
    const fullscreenWidgetName = ref(null);

    const widgetStates = ref({}); // 각 위젯의 상태를 객체로 관리 (key: widgetName, value: 상태 객체)

    function updateWidgetState(widgetName, state) {
        widgetStates.value[widgetName] = { ...widgetStates.value[widgetName], ...state };
    }

    function enterFullscreen(rawLayoutData, clickedItemName, initialState) {
        if (!rawLayoutData || rawLayoutData.length === 0) {
            return;
        }
        const userStore = useUserStore();

        const processedLayout = rawLayoutData.map(item => {
            if (!item || !item.name) {
                return null;
            }
            const chartTypeInfo = getItemChartTypeInfo(item.name);
            const legendInfo = getItemLegendInfo(item.name);

            return {
                ...item,
                selectedChartType: initialState?.selectedChartType || chartTypeInfo.default,
                selectedFiscalYear: initialState?.selectedFiscalYear || String(common.getThisYear()),
                selectedEmployeeId: initialState?.selectedEmployeeId || getInitialEmployeeId(userStore),
                selectedLegend: initialState?.selectedLegend || legendInfo.default,
                chartTypeOptions: chartTypeInfo.options,
                legendOptions: legendInfo.options,
                displayFiscalYear: shouldDisplayFiscalYear(item.name),
                displayEmployeeIdGroup1: shouldDisplayEmployeeIdGroup1(item.name, userStore.isAdmin),
                displayEmployeeIdGroup2: shouldDisplayEmployeeIdGroup2(item.name, userStore.isAdmin),
                showChartTypeSelector: chartTypeInfo.isShow,
                showLegendSelector: legendInfo.isShow,
                linkReport: getLinkReportPath(item.name)
            };
        }).filter(Boolean);
        document.body.style.overflow ='hidden'
        fullscreenLayout.value = processedLayout;
        const foundIndex = fullscreenLayout.value.findIndex(item => item.name === clickedItemName);
        activeSlideIndex.value = foundIndex >= 0 ? foundIndex : 0;
        isGlobalFullscreen.value = true;
        fullscreenWidgetName.value = clickedItemName;
        
    }

    function exitFullscreen() {
        isGlobalFullscreen.value = false;
        fullscreenWidgetName.value = null;
        document.body.style.overflow = 'unset';
    }

    return {
        isGlobalFullscreen,
        fullscreenLayout,
        activeSlideIndex,
        fullscreenWidgetName,
        widgetStates,
        updateWidgetState,
        enterFullscreen,
        exitFullscreen,
    };
});
